import React, { useState } from 'react';
import styled from 'styled-components';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';

import Hero from './HeroSection/Hero';
import CustomInput from './Inputs/CustomInput';
import SubmitButton from './Buttons/SubmitButton';
import AlertError from './Alertas/AlertError';
import { login, encryptText } from '../services/account.service';
import useThemes from '../hooks/useThemes';

const URL = 'https://back.famedicips.com.co/login';

const schema = yup.object({
  username: yup.string().required('El usuario es requerido'),
  password: yup.string().required('La contraseña es requerida'),
});

export const PageFuncionarios = () => {
  window.scroll(0, 0)
  const { handleSubmit, control, reset } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(schema),
  });
  const history = useHistory();
  const { backgroundWhite } = useThemes();

  const [isLoading, setIsloading] = useState(false);
  const [alertErrorProps, setAlertErrorProps] = useState(null);

  const onSubmit = async (data) => {
    setIsloading(true);

    try {
      const textEncrypted = await encryptText(encodeURI(data.password));

      const response = await login({
        login: data.username,
        password: textEncrypted.data,
      });
      setIsloading(false);

      if (response?.data?.apiResponse?.code === 200) {
        reset({ username: '', password: '' });
        history.push('/');
        window.open(
          `${URL}?userName=${data.username}&password=${textEncrypted.data}`,
          '_blank'
        );
      }
    } catch (error) {
      console.error(error);
      setIsloading(false);

      setAlertErrorProps({
        isOpen: true,
        titulo: error?.response?.statusText || '¡Error!',
        contenido: error?.response?.data?.apiResponse?.message,
        secondaryLabel: 'Intentar nuevamente',
        onClose: () => setAlertErrorProps({ isOpen: false }),
        primaryOnClick: () => history.push('/'),
        secondaryOnClick: () => {
          setAlertErrorProps({ isOpen: false });
        },
      });
    }
  };

  return (
    <Container background={backgroundWhite}>
      <Hero
        title='Funcionarios'
        subtitle='INGRESO AL PORTAL PARA PERSONAL FAMEDIC'
        color={backgroundWhite}
        imgSrc='img/Servicios/Citas-turnos.jpg'
      />

      <AlertError {...alertErrorProps} />

      <FormContainer
        onSubmit={handleSubmit(onSubmit)}
        background={backgroundWhite}
      >
        <InputContainer>
          <Controller
            name='username'
            control={control}
            render={({
              field: { value, onBlur, onChange },
              fieldState: { error },
            }) => (
              <CustomInput
                value={value}
                onChange={onChange}
                onBlut={onBlur}
                label='usuario *'
                width='100%'
                error={error}
                placeholder='Escriba su usuario'
              />
            )}
          />
        </InputContainer>

        <InputContainer>
          <Controller
            name='password'
            control={control}
            render={({
              field: { value, onBlur, onChange },
              fieldState: { error },
            }) => (
              <CustomInput
                value={value}
                onChange={onChange}
                onBlut={onBlur}
                label='CONTRASEÑA *'
                width='100%'
                error={error}
                type='password'
                placeholder='Escriba acá la contraseña registrada'
              />
            )}
          />
        </InputContainer>

        <SubmitButton label='Iniciar sesión' isLoading={isLoading} />
      </FormContainer>
    </Container>
  );
};

// ##### Estilos #####
const Container = styled.div`
  position: relative;
  background-color: ${(props) => props.background};
`;

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;
  margin-bottom: 0;
  padding-bottom: 3rem;
  background-color: ${(props) => props.background};
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50vw;

  @media (max-width: 1023px) {
    width: 90vw;
  }
`;
